import { TrackingData, TrackingDataVersion } from '../clients/trackingClient';
import { List, Set } from 'immutable';
import {Guid} from '../../../model/guid';

export function convertLegacyTrackingDataToCurrentFormat(
  trackingData: TrackingData,
  getLegacyPresenterData: (itemId: Guid, finishedItemIds?: Set<string>) => List<Guid> | null
) {
  if (trackingData.version === TrackingDataVersion.v1) {
    const compressedFinishedItemIds = trackingData.finishedItems.reduce(
      (result: Set<string>, item: Guid) =>
        result
          .concat(
            fixLegacyPresenterData(item, trackingData.finishedItems.concat(result).toSet(), getLegacyPresenterData)
          )
          .toSet(),
      Set()
    );
    return {
      finishedItems: compressedFinishedItemIds,
      widgetTrackingData: trackingData.widgetTrackingData,
      version: trackingData.version,
    };
  }
  return trackingData;
}

function fixLegacyPresenterData(
  retrievedId: Guid,
  finishedItemIds: Set<string>,
  getLegacyPresenterData: (itemId: Guid, finishedItemIds?: Set<string>) => List<Guid> | null
): Set<Guid> {
  const presenterData = getLegacyPresenterData(retrievedId, finishedItemIds);
  if (presenterData) {
    return presenterData.toSet();
  }
  return Set([retrievedId]);
}
